import React from 'react';
import { Card } from '../Card'; // Assumendo l'esistenza di questo componente

interface ClassSelectionProps {
  options: { name: string; value: string }[];
  onClassSelection: () => void;
  setSelectedSchoolClass: (selectedSchoolClass: string) => void;
}

const ClassSelection: React.FC<ClassSelectionProps> = ({ options, onClassSelection, setSelectedSchoolClass }) => {
  function onClick(selectedSchoolClass: string) {
    setSelectedSchoolClass(selectedSchoolClass);
    onClassSelection();
  }
  return (
    <div className="w-full bg-white rounded-lg sm:rounded-xl px-6 py-3 sm:p-6 lg:p-8 shadow-lg">
      <div className="text-center mb-4 sm:mb-6 lg:mb-8">
        <h2 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-black mb-1 sm:mb-2">
          Quale anno frequenta?
        </h2>
      </div>

      <div className="flex flex-col items-center gap-3 sm:gap-4 lg:gap-6 max-w-lg mx-auto">
        {options.map((option, index) => (
          <Card key={index} title={option.name} onClick={() => onClick(option.value)} />
        ))}
      </div>
    </div>
  );
};

export default ClassSelection;
